import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { DebounceConfig } from 'config/debounce.config';
import { DirectivesModule } from 'app/directives/directives.module';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from "@angular/material/table";
import { MatIconModule} from '@angular/material/icon';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from "@angular/material/dialog";
import { MatRadioModule} from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ManageLicensesComponent } from './licenses/manage-licenses.component';
import { ManageAdminsComponent } from './admins/manage-admins.component';
import { AdminService } from 'app/services/admin.service';
import { routes } from 'app/app-routing.module';
import { AdminCallbackComponent } from './admins/admin-callback/admin-callback.component';


@NgModule({
  declarations: [
    ManageLicensesComponent,
    ManageAdminsComponent,
    AdminCallbackComponent
  ],
  imports: [ 
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    FormsModule,
    DirectivesModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatExpansionModule,
    MatFormFieldModule,
	  MatInputModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  providers: [
    DebounceConfig,
    AdminService
  ]
})
export class OCMAdminModule {}
